import React from 'react';
import clsx from 'clsx';
import { Search } from '@material-ui/icons';
import { InputBase, withStyles } from "@material-ui/core";

const styles = theme => ({
    searchContainer: {
        display: 'flex',
        position: 'relative',
        marginLeft: 0,
        width: '100% !important',
        [theme.breakpoints.up('sm')]: {
            marginLeft: 'auto',
            width: 'auto',
        },
    },
    searchIcon: {
        zIndex: 1,
        width: '50px',
        height: '100%',
        position: 'absolute',
        pointerEvents: 'dense',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6EA0D7'
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    normalWidth: {
        width: '35%',
    },
    fullWidth: {
        width: '100%',
    },
    inputSearch: {
        height: '20px',
        border: '1px solid #E6EDF5',
        background: 'white',
        borderRadius: '4px',
        color: '#878787',
        padding: '9px 10px 9px 50px',
        '&:hover': {
            border: '1px solid #B5CBE3',
            color: '#545454'
        },
        '&:active, &:focus': {
            border: '1px solid #6EA0D7',
            color: '#767676'
        }
    },
})

const SearchInput = (props) => {
    let { classes, wrapperClass, placeholder, onChange, value, className, fullWidth = false } = props;
    return (
        <div className={clsx(classes.searchContainer, wrapperClass)}>
            <div className={classes.searchIcon}>
                <Search />
            </div>
            <InputBase
                placeholder={placeholder}
                onChange={(e) => { onChange(e) }}
                classes={{
                    root: classes.inputRoot,
                    input: clsx(fullWidth ? classes.fullWidth : classes.normalWidth, classes.inputSearch, className),
                }}
                value={value}
                type="search"
            />
        </div>
    );
}

export default withStyles(styles)(SearchInput);
